module.exports = __webpack_public_path__ + "img/img-flow-2-3.957fcd07.png";